import React from 'react'; 
import {observer} from 'mobx-react'; 
import {Panel, FormLayout, Select2, Input} from 'components';
import {t} from 'shared/core';

const StandardCoverageForm = observer(({uiState}) => {
  const {currentCoverage, errors} = uiState;

  return (
    <div>
      <Panel.Separator />
      <Panel.Subheader title={t('taxable_benefits.Standard Information')} />
      <FormLayout>
        {!currentCoverage.isOptionalCoverage && <Select2 value={currentCoverage.premiumSplitType}
          onChange={e => currentCoverage.premiumSplitType = e.target.value}
          label='taxable_benefits.Premium Split Type'
          helpMessage='taxable_benefits.help_text.premium_split_type'
          allowClear 
        >
          <option value='amount'>{t('taxable_benefits.Amount')}</option>
          <option value='percentage'>{t('taxable_benefits.Percent')}</option>
        </Select2>}
        {currentCoverage.premiumSplitType === 'amount' &&
          <Input value={currentCoverage.premiumSplitAmount}
            onChange={e => currentCoverage.merge({premiumSplitAmount: e.target.value})}
            errorMessage={errors.premiumSplitAmount}
            label='taxable_benefits.Premium Split Amount'
            helpMessage='taxable_benefits.help_text.premium_split_amount'
          />}
        {currentCoverage.premiumSplitType === 'percentage' &&
          <Input value={currentCoverage.premiumSplitPercentage}
            onChange={e => currentCoverage.merge({premiumSplitPercentage: e.target.value})}
            label='taxable_benefits.Premium Split Percentage'
            errorMessage={errors.premiumSplitPercentage}
            helpMessage='taxable_benefits.help_text.premium_split_percentage'
            translatePlaceholder={false}
            placeholder='50%'
          />}
        <Input value={currentCoverage.terminationAge}
          onChange={e => currentCoverage.merge({terminationAge: e.target.value})}
          label='taxable_benefits.Termination Age'
          errorMessage={errors.terminationAge}
        />
        {!currentCoverage.isOptionalCoverage && <Select2 value={currentCoverage.salesTaxRegion}
          onChange={e => currentCoverage.merge({salesTaxRegion: e.target.value})}
          label='taxable_benefits.Sales Tax Region'
          errorMessage={errors.salesTaxRegion}
          helpMessage='taxable_benefits.help_text.sales_tax_region'>
          <option value='employee'>{t('taxable_benefits.Employee')}</option>
          <option value='company'>{t('taxable_benefits.Company')}</option>
        </Select2>}
      </FormLayout>
    </div>
  );
});

export default StandardCoverageForm;
